import { registerMicroApps, loadMicroApp } from 'qiankun'
import { bindQiankunGlobalErrorLog, markQiankunMounted } from '@common/qiankunWatchdog'

export function registerApps(parent, activeRule) {
  try {
    const timeStr = Date.now();
    const entryPath = process.env.NODE_ENV === 'production' ? `/onlinePlayingList/`: '//localhost:8888'
    registerMicroApps(
      [
        {
          name: 'online-playing-list', // 子应用名称，跟package.json一致
          entry: entryPath + "?time=" + timeStr, // 子应用入口，本地环境下指定端口
          container: '#onLinePlaying-content', // 挂载子应用的dom
          activeRule: activeRule, // 路由匹配规则
          props: {
            parentInstance: parent,
            activeRule
          } // 主应用与子应用通信传值
        },
      ], {
      beforeLoad: [
        app => {
          console.log('before load', app)
        }
      ],
      beforeMount: [
        app => {
          console.log('before mount', app)
        }
      ],
      afterMount: [
        app => {
          console.log('after mount', app)
          // 看门狗的健康打点：子应用真正 mount 完成的时间戳
          markQiankunMounted()
        }
      ],
      afterUnmount: [
        app => {
          console.log('before unmount', app)
        }
      ]
    })

    // 子应用资源加载失败的全局日志兜底（自愈看门狗在页面 mounted 里武装）
    bindQiankunGlobalErrorLog()
  } catch (err) {
    console.log(err)
  }
}


